// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__300WS","alert":"SettungsInbox_alert__2czB9"};